import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/burda-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-b935bba2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "unauthorized-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "205",
    height: "50",
    alt: "Burda logo"
  })
], -1))
const _hoisted_3 = {
  key: 0,
  class: "text--center"
}

import { withDefaults } from 'vue';
import BasePending from '@/components/layout/BasePending.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    width: { default: '300px' },
    title: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { width: string, title: string }



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "box",
        style: _normalizeStyle(`width: ${__props.width};`)
      }, [
        _hoisted_2,
        (__props.title)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(__props.title), 1))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default")
      ], 4)
    ]),
    _createVNode(BasePending)
  ], 64))
}
}

})